// import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

// /**
//  * A custom element that displays a product price.
//  * This component listens for variant update events and updates the price display accordingly.
//  * It handles price updates from two different sources:
//  * 1. Variant picker (in quick add modal or product page)
//  * 2. Swatches variant picker (in product cards)
//  */
// class ProductPrice extends HTMLElement {
//   connectedCallback() {
//     const closestSection = this.closest('.shopify-section, dialog');
//     if (!closestSection) return;
//     closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
//   }

//   disconnectedCallback() {
//     const closestSection = this.closest('.shopify-section, dialog');
//     if (!closestSection) return;
//     closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
//   }

//   /**
//    * Updates the price.
//    * @param {VariantUpdateEvent} event - The variant update event.
//    */
//   updatePrice = (event) => {
//     if (event.detail.data.newProduct) {
//       this.dataset.productId = event.detail.data.newProduct.id;
//     } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
//       return;
//     }

//     const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
//     const currentPrice = this.querySelector('[ref="priceContainer"]');

//     if (!newPrice || !currentPrice) return;

//     if (currentPrice.innerHTML !== newPrice.innerHTML) {
//       currentPrice.replaceWith(newPrice);
//     }
//   };
// }

// if (!customElements.get('product-price')) {
//   customElements.define('product-price', ProductPrice);
// }

import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    const priceElement = this.querySelector('[ref="priceContainer"] .price');
    if (!priceElement) return;

    // Get numeric unit price
    this.unitPrice = parseFloat(this.querySelector('[ref="priceContainer"]').dataset.unitPrice) || 0;
    this.currencySymbol = priceElement.textContent.replace(/[0-9.,\s]/g, '') || '';

    // Listen for variant updates
    const section = this.closest('.shopify-section, dialog');
    if (section) {
      section.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    }

    // Listen for changes on Horizon quantity input
    const quantityInput = document.querySelector('input[ref="quantityInput"]');
    if (quantityInput) {
      quantityInput.addEventListener('input', () => {
        this.updateTotalPrice(quantityInput.value);
      });

      // Also listen for plus/minus button clicks inside quantity selector
      const quantitySelector = quantityInput.closest('quantity-selector-component');
      if (quantitySelector) {
        const buttons = quantitySelector.querySelectorAll('button');
        buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.updateTotalPrice(quantityInput.value);
          });
        });
      }
    }
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (section) {
      section.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    }
  }

  // Update price on variant change
  updatePrice = (event) => {
    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');
    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
      const priceEl = this.querySelector('[ref="priceContainer"] .price');
      if (priceEl) {
        this.unitPrice = parseFloat(this.querySelector('[ref="priceContainer"]').dataset.unitPrice) || 0;
        this.currencySymbol = priceEl.textContent.replace(/[0-9.,\s]/g, '') || '';
      }
    }

    // Update total price with current quantity
    const quantityInput = document.querySelector('input[ref="quantityInput"]');
    if (quantityInput) this.updateTotalPrice(quantityInput.value);
  };

  // Multiply unit price × quantity
  updateTotalPrice(quantity) {
    if (!this.unitPrice || !quantity) return;

    const priceElement = this.querySelector('[ref="priceContainer"] .price');
    if (!priceElement) return;

    const total = (this.unitPrice * parseInt(quantity)).toFixed(2);
    priceElement.textContent = `${this.currencySymbol}${total}`;
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
